import { VER_STAGE_LABELS, type ProjectStatus, type ProjectType, type VerStage } from '@raro/domain';

export function greeting(date = new Date()) {
  const h = date.getHours();
  if (h < 6) return 'boa madrugada.';
  if (h < 12) return 'bom dia.';
  if (h < 18) return 'boa tarde.';
  return 'boa noite.';
}

export const PROJECT_TYPE_LABELS: Record<ProjectType, string> = {
  ver: 'VER',
  live: 'LIVE',
  continuous: 'CONTÍNUO',
  make: 'FAZER',
  other: 'OUTRO',
};

export const PROJECT_STATUS_LABELS: Record<ProjectStatus, string> = {
  draft: 'rascunho',
  active: 'em andamento',
  paused: 'pausado',
  closed: 'encerrado',
};

export function stageLabel(stage: VerStage | null | undefined) {
  return stage ? VER_STAGE_LABELS[stage] : '—';
}

export function formatNumber(n: number) {
  return new Intl.NumberFormat('pt-BR').format(n);
}

export function formatDate(iso: string | null | undefined) {
  if (!iso) return '—';
  return new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: 'short', year: 'numeric' }).format(new Date(iso));
}

export function daysLeft(iso: string | null | undefined) {
  if (!iso) return null;
  const diff = Math.ceil((new Date(iso).getTime() - Date.now()) / 86_400_000);
  return diff;
}

import type { EvidenceType, HumanStatus, SourceLocation, SourceProcessingStatus, SourceType } from '@raro/domain';

export const SOURCE_TYPE_LABELS: Record<SourceType, string> = {
  interview: 'entrevista',
  document: 'documento',
  spreadsheet: 'planilha',
  image: 'imagem',
  video: 'vídeo',
  audio: 'áudio',
  url: 'link',
  field_note: 'nota de campo',
  research: 'pesquisa',
  analytics: 'analytics',
  crm: 'crm',
  social: 'social',
  review: 'avaliação',
  meeting: 'reunião',
  other: 'outro',
};

export const SOURCE_STATUS_LABELS: Record<SourceProcessingStatus, string> = {
  uploaded: 'enviado',
  queued: 'na fila',
  processing: 'processando',
  processed: 'processado',
  failed: 'falhou',
};

export const EVIDENCE_TYPE_LABELS: Record<EvidenceType, string> = {
  quote: 'citação',
  data: 'dado',
  image: 'imagem',
  behavior: 'comportamento',
  document: 'documento',
  other: 'outro',
};

export const HUMAN_STATUS_LABELS: Record<HumanStatus, string> = {
  under_review: 'em revisão',
  accepted: 'aceita',
  rejected: 'rejeitada',
};

export function locationLabel(loc: SourceLocation | null | undefined) {
  if (!loc) return '';
  if (loc.label) return loc.label;
  if (loc.page) return `p. ${loc.page}`;
  if (loc.slide) return `slide ${loc.slide}`;
  if (loc.sheet) return loc.cell ? `${loc.sheet}!${loc.cell}` : loc.sheet;
  if (loc.startMs !== undefined) {
    const s = Math.floor(loc.startMs / 1000);
    return `${String(Math.floor(s / 60)).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`;
  }
  return '';
}

export function sourceIsPending(status: SourceProcessingStatus) {
  return status === 'uploaded' || status === 'queued' || status === 'processing';
}

import type { HypothesisStatus, QuestionStatus, StatementKind } from '@raro/domain';

export const QUESTION_STATUS_LABELS: Record<QuestionStatus, string> = { open: 'aberta', investigating: 'investigando', answered: 'respondida', obsolete: 'obsoleta' };
export const HYPOTHESIS_STATUS_LABELS: Record<HypothesisStatus, string> = { proposed: 'proposta', investigating: 'investigando', supported: 'sustentada', weakened: 'enfraquecida', rejected: 'rejeitada', parked: 'estacionada' };
export const STATEMENT_KIND_LABELS: Record<StatementKind, string> = { fact: 'fato', observation: 'observação', opinion: 'opinião', signal: 'sinal', inference: 'inferência', hypothesis: 'hipótese', decision: 'decisão', learning: 'aprendizado' };

export function formatMoney(v: number | null | undefined) {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 }).format(Number(v ?? 0));
}
